// STAGING — tous les logs sont actifs pour faciliter le débogage
export const logger = {
  log: (...args: unknown[]) => console.log('[STAGING]', ...args),
  error: (...args: unknown[]) => console.error('[STAGING]', ...args),
  warn: (...args: unknown[]) => console.warn('[STAGING]', ...args),
  info: (...args: unknown[]) => console.info('[STAGING]', ...args),
};
